import {getChestDisplayName} from '../inventory/getChestDisplayName';
import {getChestIconPath} from '../inventory/getChestIconPath';
import {getFormattedPrice} from '../price/getFormattedPrice';

/**
 * Резолвит награду ежедневного входа (объект reward — {numens}/{crystals}/
 * {chestId}, ровно тот, что хранится как есть в истории claim'ов) в
 * имя/иконку для отображения.
 */
export function resolveDailyLoginRewardDisplay(reward) {
  if (!reward) {
    return {name: '—', iconPath: null};
  }
  if (reward.chestId) {
    return {
      name: getChestDisplayName(reward.chestId),
      iconPath: getChestIconPath(reward.chestId),
    };
  }
  if (reward.crystals) {
    return {
      name: getFormattedPrice(reward.crystals),
      iconPath: '/img/icons/crystal.png',
      isCrystals: true,
    };
  }
  return {
    name: getFormattedPrice(reward.numens || 0),
    iconPath: '/img/icons/numens.png',
    isNumens: true,
  };
}
